import {
	HANDLE_INPUT_BLUR,
	HANDLE_INPUT_CHANGE,
	type IOnboardingState,
	type OnboardingActionTypes,
	TOGGLE_AGREE_TERMS,
	UPDATE_SUBMIT_STATE,
} from './types';

export default function onboardingReducer(
	state: IOnboardingState,
	action: OnboardingActionTypes,
) {
	switch (action.type) {
		case HANDLE_INPUT_CHANGE: {
			const newState = {
				...state,
				input: action.payload,
			};
			if (state.errorOnBlur && action.payload.isValid) {
				newState.errorOnBlur = false;
			}

			return newState;
		}
		case HANDLE_INPUT_BLUR: {
			return {
				...state,
				errorOnBlur: !state.input.isValid,
			};
		}
		case TOGGLE_AGREE_TERMS:
			return {
				...state,
				agreeTerms: !state.agreeTerms,
			};
		case UPDATE_SUBMIT_STATE:
			return {
				...state,
				submitted: action.submit,
			};
		default:
			return state;
	}
}
